module.exports = __webpack_public_path__ + "img/SES_38062430.462a2003.jpg";